import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  notificationPreference: generateApiPath({ prefix: AuthLevel.AUTH, name: 'notification-preference' }),
}

export { paths }
